"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _slice = require("@lce/slice");

var _api = require("@lce/api");

var Styled = _interopRequireWildcard(require("./Address.style"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Address = function Address(_a) {
  var type = _a.type;
  var addresses = (0, _api.useAddress)().addresses;
  var address = addresses === null || addresses === void 0 ? void 0 : addresses[type];
  return (address === null || address === void 0 ? void 0 : address.street) ? _react["default"].createElement(_slice.Box, {
    mb: 4
  }, _react["default"].createElement(Styled.Address, {
    "data-testid": "mini-cart__store-address"
  }, address.street.toLowerCase())) : null;
};

var _default = Address;
exports["default"] = _default;